<template>
  <div class="modal-card">
    <header class="modal-card-head pop-header">
      <p class="modal-card-title tit">
        롯데에너지머티리얼즈 방문예약시스템 서비스 이전 안내
      </p>
    </header>
    <section class="modal-card-body pop-content" style="height:260px">
      <div class="inner-box">
        <div style="height: 160px; margin-bottom: 10px; font-size: 20px; text-align: left">
          <div style="font-weight: bold; font-size: 23px; color:#0065b3; margin-bottom: 10px;">2024년 12월 31일부터</div>롯데에너지머티리얼즈 방문등록을 위한 사이트 접속이 아래와 같이 변경됩니다.
          <br>아래 링크로 접속하셔서 등록하시기 바랍니다.
          <span style="color:#0065b3; cursor: pointer" @click="redirectModal">[https://vms.lotteenergymaterials.com]</span>
        </div>
        <button class="button-close" @click="redirectModal" style="margin-top: 10px">
          이동
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "endServicePop",
  data() {
    return {
      title: "안전교육",
      agreeChk: false,
      isScrollDown: false,
      scrollTop: 0,
      target: null,
      scrollPosition: 0
    }
  },
  methods: {
    redirectModal() {
      var targetUrl = "https://vms.lotteenergymaterials.com";

      // 페이지 리다이렉트
      window.location.href = targetUrl;
    },
    handleScroll() {
      this.scrollTop = this.target.scrollHeight - this.target.scrollTop - this.target.clientHeight

      if(this.scrollTop < 50) {
        this.isScrollDown = true
      } else {
        this.isScrollDown = false
      }
    }
  },

  mounted() {
  },
}
</script>

<style>
.inner-box{
  height: 100%;
  width:100%;
  left: 0;
  right: 0;
}

.inner-box button{
  padding:10px;
  border:1px solid #d5d5d5;
  text-align:center;
  font-weight: bold;
}

.inner-box .button-request{
  background-color: #023e7c;
  color:#fff;
  width:100px;
}

.inner-box .button-close{
  background-color: #023e7c;
  color:#fff;
  width:100px;
  margin-left:10px;
}

.modal-content{
  max-width: 650px;
}
.modal-card {
  width: 100%;
}

</style>